import { Box, Typography } from "@mui/material";

const HeaderTopLink = ({ name, fn }: { name: string; fn: (x: any) => any }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        "&:hover .hover-child": {
          visibility: "visible",
          opacity: 1,
          transform: "translateY(-5%)", // final position
        },
        "&:hover .name": {
          color: "#FE6F61", // new color
          fontSize: { sm: "0.901rem", md: "1.01rem" }, // slightly larger
          transition: "color 0.3s ease, font-size 0.3s ease 0.25s",
        },
        cursor: "pointer",
      }}
      onClick={fn}
    >
      <Box
        className='hover-child'
        sx={{
          visibility: "hidden",
          opacity: 0,
          transform: "translateY(70%)", // start below
          transition: "all 0.25s ease", // animate visibility/opacity/position
        }}
      >
        <Box
          component='span'
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: "#FE6F61",
            display: "inline-block",
          }}
        ></Box>
      </Box>
      <Typography
        className='name'
        sx={{
          color: "#003466",
          fontWeight: 500,
          fontSize: { sm: "0.9rem", md: "1rem" },
          cursor: "pointer",
          "&:hover": { color: "#003466" },
          transition: "color 0.3s ease, font-size 0.3s ease",
        }}
      >
        {name}
      </Typography>
    </Box>
  );
};

export default HeaderTopLink;
